import { useState } from "react";
import { Phone, Mail, Headphones } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Reveal, Eyebrow } from "./Reveal";
import { TicketForm } from "./TicketForm";
import { TicketLookup } from "./TicketLookup";

const ContactRow = ({ Icon, label, value, href, testId }) => (
  <a href={href} data-testid={testId} className="group flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-4 transition-colors hover:border-blue-300">
    <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#FACC15] text-[#070B14] transition-transform group-hover:rotate-[-10deg]"><Icon className="h-5 w-5" /></span>
    <span><span className="block text-xs font-semibold uppercase tracking-wider text-slate-600">{label}</span><span className="font-display block text-lg font-bold text-slate-900">{value}</span></span>
  </a>
);

export const Support = ({ s }) => {
  const [tab, setTab] = useState("new");
  const [prefill, setPrefill] = useState(null);
  return (
    <section id="support" className="relative border-t border-slate-200 bg-[#F3F7FF] py-28 lg:py-36" data-testid="support-section">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 lg:grid-cols-12 lg:px-8">
        <Reveal className="lg:col-span-5">
          <Eyebrow>24/7 live phone support</Eyebrow>
          <h2 className="font-display mt-6 text-3xl font-extrabold leading-tight tracking-tight text-slate-900 sm:text-4xl">Real People.<br />Real Support.<br /><span className="text-blue-600">Always.</span></h2>
          <div className="relative mt-10 aspect-[4/3] overflow-hidden rounded-3xl border border-slate-200 [clip-path:polygon(0_0,100%_0,100%_86%,86%_100%,0_100%)]">
            <img src="/img/headset.jpg" alt="Support headset" className="h-full w-full object-cover transition-transform duration-[1.6s] hover:scale-105" />
          </div>
          <div className="mt-6 space-y-3">
            {s.phone && <ContactRow Icon={Phone} label="Call us 24/7" value={s.phone} href={`tel:${s.phone.replace(/[^\d+]/g, "")}`} testId="support-phone" />}
            {s.email && <ContactRow Icon={Mail} label="Email support" value={s.email} href={`mailto:${s.email}`} testId="support-email" />}
            {!s.phone && !s.email && <ContactRow Icon={Headphones} label="Fastest way to reach us" value="Open a support ticket" href="#support" testId="support-ticket-fallback" />}
          </div>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-7">
          <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-[0_30px_80px_-40px_rgba(37,99,235,0.4)] sm:p-10">
            <Tabs value={tab} onValueChange={setTab}>
              <TabsList className="mb-8 grid h-auto w-full grid-cols-2 rounded-full bg-slate-100 p-1">
                <TabsTrigger value="new" data-testid="support-tab-new" className="rounded-full py-2.5 font-bold data-[state=active]:bg-blue-600 data-[state=active]:text-white">Open a ticket</TabsTrigger>
                <TabsTrigger value="track" data-testid="support-tab-track" className="rounded-full py-2.5 font-bold data-[state=active]:bg-blue-600 data-[state=active]:text-white">Track a ticket</TabsTrigger>
              </TabsList>
              <TabsContent value="new" forceMount className="data-[state=inactive]:hidden"><TicketForm onCreated={(c) => { setPrefill(c); setTab("track"); }} /></TabsContent>
              <TabsContent value="track" forceMount className="data-[state=inactive]:hidden"><TicketLookup prefill={prefill} /></TabsContent>
            </Tabs>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
